import React, { Component } from 'react';
import AllocateForm from './AllocateForm';
import axios from 'axios'
import { Loader } from 'monday-ui-react-core';
import { Button, TextField, Flex, ModalFooter, ModalContent, Modal, } from 'monday-ui-react-core';
import env from "react-dotenv";
let baseUrl = process.env.REACT_APP_SERVER_URL;

export default class HandleRequest extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stocks:'',
            status: '',
            description: '',
            assetId: '',
            assetName: '',
            requests: [],
            isManagerIdPresent: true,
            recievedResponse: 0,
            isloading: true,
            managerData: '',
            isRequest:true,
            userId:this.props.userId,
            accountId:this.props.accountId,
            workSpaceId:this.props.workSpaceId,
            managerIds:''
        }
    }

    async componentDidMount() {
        if (localStorage.getItem("managerId")) {
            this.setState({
                managerId: localStorage.getItem("managerId")
            })
        }
        else {
            this.setState({
                isManagerIdPresent: false
            })
        }
        await this.mondayListenProcess();
    }

    setManagerId = () => {
        localStorage.setItem("managerId", this.state.managerData);
        this.setState({
            isManagerIdPresent: true
        })
        window.location.reload()
    }

    onChangeManagerData = (eventManagerData) => {
        this.setState({
            managerData: eventManagerData
        })
        
    }

    onClickRequest = () =>{
        this.setState({isRequest:!this.state.isRequest})
    }

    mondayListenProcess = async () => {
        
        let assetId = window.location.search
        assetId = assetId.split('&')
        assetId = assetId[0].split('=')
        let param = {
            "assetId": assetId[1],
            "managerId": localStorage.getItem("managerId")
        }
        await axios.get(`${baseUrl}/fetch-asset`, { params: param })
            .then((data) => {
                this.setState({
                    status: data.data.status,
                    description: data.data.description,
                    assetId: assetId[1],
                    assetName: data.data.name,
                    stocks:data.data.stock,
                    isloading:false
                })

            })
            .catch((err) => {
                this.setState({ isManagerIdPresent: false,
                    isloading:false
                 })
            })

        let requestParams = {
            "workSpaceId": this.props.workSpaceId,
            // "userId":this.props.userId,
            "managerId": localStorage.getItem("managerId")
        }
        this.setState({
            managerIds:localStorage.getItem('managerId')
        })
        await axios.get(`${baseUrl}/fetch-requests`,{params:requestParams})
        .then((data)=>{
            let reqOptions = []
            return reqOptions
        })
        .then((data)=>{
            this.setState( {
                requests:data,
                isloading:false
            })
        })
        .catch((err)=>{
            this.setState({
                isManagerIdPresent:false,
                isloading:false
            })
        })
    }
    render() {
        const { assetName, status, assetId, description,managerIds, stocks, requests, isManagerIdPresent, isloading, isRequest } = this.state;
        return (
            <div style={{ }}>
                {isloading ?
                    <div className='loader'>
                        <Loader color="var(--primary-color)" hasBackground size={64} />
                    </div> :
                    <>
                    <br/>
                        <Button style={{display:"none"}} onClick={this.onClickRequest}>{isRequest?"Return Items":"Allocate Items"}</Button>
                        {this.state.isRequest?
                    <>
                        <AllocateForm assetName={assetName} status={status} assetId={assetId} description={description} stocks={stocks} isRequest={true}/>
                        </>
                        :
                        <AllocateForm assetName={assetName} status={status} assetId={assetId} description={description} stocks={stocks} isRequest={false}/>
                        }

                        <div>
                            <Modal
                                id="story-book-modal"
                                onClose={false}
                                title="Please fill the details below"
                                triggerElement={null}
                                show={!this.state.isManagerIdPresent}
                            >
                                <ModalContent>
                                {
                                    managerIds!==null?
                                    <div style={{color:'red'}}>
                                        Enter a valid Manager ID
                                    </div>:null
                                }
                                    <TextField
                                        title="Asset Manager Id"
                                        id="managerId"
                                        onChange={this.onChangeManagerData}
                                        value={this.state.managerData}
                                        wrapperClassName="monday-storybook-text-field_size"
                                    />
                                </ModalContent>
                                <ModalFooter>
                                    <Flex

                                        gap={12}
                                        justify="End"
                                    >
                                        <Button onClick={this.setManagerId}>
                                            Submit
                                        </Button>
                                    </Flex>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </>}
            </div>
        )
    }
}
